// extracted by mini-css-extract-plugin
export var address = "styles-module--address--d4188";
export var image = "styles-module--image--3e827";
export var place = "styles-module--place--3c7e9";
export var places = "styles-module--places--27990";
export var title = "styles-module--title--ae28e";
export var wrapper = "styles-module--wrapper--65671";